import React from 'react';

import StepperComponent, { Stepper } from 'retired/Stepper/index';
import { truthy } from 'utils/truthy';

export type AutoStep = { labelText: string; children: JSX.Element; id?: string } | false | null;

type Props = { steps: AutoStep[] };

export const AutoStepper = (props: Props) => (
  <Stepper orientation="vertical">
    {props.steps.filter(truthy).map(({ labelText, children, id }, index) => (
      <StepperComponent labelText={labelText} componentIndex={index} key={labelText} id={id}>
        {children}
      </StepperComponent>
    ))}
  </Stepper>
);
